import { useMemo } from "react"
import { useTheme } from "@mui/material"
import { useTranslation } from "react-i18next"

import type { RecordType, PiePlotView } from "types/dashboard.types"
import type { IPieConfig } from "types/piePlot.types"

import { pieConfig } from "./pie"

export default function usePieConfig(view: PiePlotView, data: RecordType[]) {
  const { palette } = useTheme()
  const { t } = useTranslation()

  const graphConfig: IPieConfig = useMemo(
    () => pieConfig({ view, data, palette, t }),
    [view, data, palette, t],
  )

  return graphConfig
}
